module.exports = __webpack_public_path__ + "img/pt-BR.a8cab51.png";